import {Component, OnInit, ViewChild} from '@angular/core';
import {Chunker} from '../framework/chunker';
import {UITableComponentHeader, UITableComponentOptions} from '../framework/ui/table';
import {ApprovalRequestEntity, QARService, SORUserEntity} from '../services/qar.service';
import {FileInfo, UploadInterface} from '../framework/ui/uploader';
import {UIInputAutocompleterComponent} from '../framework/ui/input-autocompleter';

@Component({
	selector: 'app-page-approval-requests',
	templateUrl: './approval-requests.html',
	providers: [QARService]
})
export class ApprovalRequestsPageComponent implements OnInit, UploadInterface {

	@ViewChild('autocompleter', {static: true}) autocompleter: UIInputAutocompleterComponent;

	self = this;

	public constructor(public api: QARService) {
	}


	public requests = {
		chunker: new Chunker([]),
		chunkedData: [],
		loading: false,
		tableHeaders: [
			{id: 'Type', label: 'Type', filterable: true},
			{id: 'Reference', label: 'Reference', filterable: true},
			{id: 'CreatedDate', label: 'Date Created', filterable: true, type: 'date', style: 'width:100px'},
			{id: 'SORUser', label: 'Approver Name', filterable: true, idFunction: this.helper_idFunctionSORUserName},
			{id: 'SORUser', label: 'Approver Email', filterable: true, idFunction: this.helper_idFunctionSORUserEmail},
			{id: 'StatusId', label: 'Status', filterable: true},
			{id: 'DecisionDate', label: 'Decision Date', filterable: true, type: 'date'},
			{id: 'NeedCountersigning', label: 'Counter Signing', filterable: true, idFunction: this.helper_idFunctionNeedCountersigning},
			{id: ''},
		] as UITableComponentHeader[]
	};

	ngOnInit() {
		this.requests.loading = true;
		this.api.retrieveApprovalRequests().then(r => {
			this.requests.loading = false;
			this.requests.chunker = new Chunker(r);
		});
	}

	selectedOptions(value: string): void {
		if (this.new.selectedOpt.includes(value)) {
			this.new.selectedOpt = this.new.selectedOpt.filter((item) => item !== value);
		} else {
			this.new.selectedOpt.push(value);
		}
	}

	public new = {
		request: new ApprovalRequestEntity(),
		userList: [],
		file: null,
		EmailBody: '',
		EmailSubject: '',
		uploadedFile: {Name: '', Base64: null},
		errors: [],
		saving: false,
		canCounterSign: false,
		PossibleStatuses: '',
		selectedOpt: [],
		options: [
			// it is always available : 'pending',
			// exist but we won't make it available: 'sign_off_not_sought',
			'acknowledged',
			'modified',
			'approved',
			'rejected'
			// it is always available : 'cancelled'
		]
	};

	new_addUser() {
		const user = this.autocompleter.formControl.value;
		this.new.userList.push(user);
		this.autocompleter.formControl.setValue('');
		this.autocompleter.formControl.reset();
	}

	public userList_Remove(u, index) {
		console.log('userList_Remove', u, this.new.userList, index);
		this.new.userList.splice(index, 1);
	}

	public new_submit($event) {
		console.log('new_submit', this.new.request, {userList: this.new.userList});
		// check
		const errors = [];
		if (!this.new.request.Type) {
			errors.push('Missing Type');
		}
		if (!this.new.request.Reference) {
			errors.push('Missing Reference');
		}
		if (!this.new.request.Description) {
			errors.push('Missing Description');
		}
		if (!this.new.EmailBody) {
			errors.push('Missing Email Body');
		}
		if (!this.new.EmailSubject) {
			errors.push('Missing Email Subject');
		}
		if (!this.new.selectedOpt.length) {
			errors.push('Missing selection of "Approval Options"');
		}
		if (this.new.uploadedFile.Name === '') {
			errors.push('Missing File');
		}
		if (!this.new.userList.length) {
			errors.push('Missing Users');
		}

		if (errors.length) {
			this.new.errors = errors;
		} else {
			this.new.PossibleStatuses = this.new.selectedOpt.join('|');
			this.new.saving = true;
			this.api.approvalRequestNewBatch(this.new.request.Type, this.new.request.Reference, this.new.request.Description, this.new.EmailSubject, this.new.EmailBody, this.new.userList, this.new.uploadedFile, this.new.PossibleStatuses, this.new.canCounterSign).then(r => {
				this.ngOnInit();
				alert('Sent to ' + r['emails'].join(',' + '\r\n'));
				document.location.reload();
			}, e => {
				alert('error!');
			}).finally(() => {
				this.new.saving = false;
			});
		}
	}

	public selectedOptionsCounterSign(cter, $event) {
		this.new.canCounterSign = !this.new.canCounterSign;
	}

	public helper_idFunctionSORUserName(ar: ApprovalRequestEntity) {
		return ar.SORUser.FirstName + ' ' + ar.SORUser.LastName;
	}

	public helper_idFunctionSORUserEmail(ar: ApprovalRequestEntity) {
		return ar.SORUser.Email;
	}

	public helper_idFunctionNeedCountersigning(ar: ApprovalRequestEntity) {
		return ar.NeedCountersigning ? (ar.CounterSignedBy ? 'Counter Signed' : 'Pending') : 'N/A';
	}

	public helper_autocomplete_displaySelectedUsername(option: SORUserEntity) {
		if (!option) {
			return '';
		}
		return option.FirstName + ' ' + option.LastName + ' (' + option.Login + ')';
	}

	public helper_autocomplete_search(search) {
		return this.api.searchSORUser(search);
	}

	uploadAcceptsFile(file: File) {
		console.log('uploadAcceptsFile', file);
		const reader = new FileReader();
		reader.readAsDataURL(file); // alternatively you can use readAsDataURL

		reader.onloadend = (evt: ProgressEvent) => {
			console.log('uploadAcceptsFile loaded', evt);
		};
		reader.addEventListener('load', () => {
			// convert image file to base64 string
			console.log(reader.result);
			this.new.uploadedFile = ({Name: file.name, Base64: reader.result});
		}, false);

		return true;
	}

	uploadDone(files: FileInfo[]) {

	}

}
